import { CampaignRedeem } from '../campaign';
import { Employee } from '../employee';
import { bindData, bindDjangoData } from '../helpers/object';
import { Proposal } from '../proposal';

export class PaycheckAdvanceBonus {
  id = '';
  employee = new Employee();
  campaignRedeem = new CampaignRedeem();
  proposal = new Proposal();
  used = false;
  bonusAmount = 0;
  expired = true;

  constructor(data: string | PaycheckAdvanceBonus | any = {}) {
    if (typeof data === 'string') {
      bindDjangoData<PaycheckAdvanceBonus, DjangoPaycheckAdvanceBonus>(this, { id: data });
    } else if (data instanceof PaycheckAdvanceBonus) {
      bindData<PaycheckAdvanceBonus>(this, data);
    } else {
      bindDjangoData(this, data);
    }
  }
}

export interface DjangoPaycheckAdvanceBonus {
  id: string;
  employee?: Employee;
  campaign_redeem?: CampaignRedeem;
  proposal?: Proposal;
  used?: boolean;
  bonus_amount?: number;
  expired?: boolean;
}

export function parsePaycheckAdvanceBonus(
  data: string | PaycheckAdvanceBonus | DjangoPaycheckAdvanceBonus,
) {
  if (data) {
    return new PaycheckAdvanceBonus(data);
  } else {
    return undefined;
  }
}
